import React from "react";
import { SkeletonAvatar, SkeletonBlock, SkeletonText } from "./Skeleton";

/**
 * Post-card skeleton, shared by every feed-shaped surface: Feed, Saved posts,
 * Paid content, and the Posts tab on a profile.
 *
 * Shape: author row (avatar + handle + timestamp), two or three body lines, and
 * — on every other card — a media rectangle. The action row is NOT drawn: like,
 * comment and repost are interactive, and a grey block where a button goes gets
 * tapped.
 */

const PostSkeleton = ({ withMedia = false }) => (
  <div aria-hidden="true" className="border-b border-divider py-5">
    <div className="flex items-start gap-3">
      <SkeletonAvatar size={44} />
      <div className="flex-1 min-w-0">
        <SkeletonBlock height={13} width="38%" />
        <SkeletonBlock height={10} width="22%" className="mt-2" />
      </div>
    </div>
    <SkeletonText
      lines={2}
      height={12}
      lastLineWidth="62%"
      className="mt-4"
    />
    {withMedia && (
      <SkeletonBlock
        height={200}
        rounded="rounded-xl"
        className="mt-4"
      />
    )}
  </div>
);

const PostListSkeleton = ({ posts = 3, className = "" }) => (
  <div aria-busy="true" aria-label="Posts loading" className={className}>
    {Array.from({ length: posts }).map((_, i) => (
      <PostSkeleton key={i} withMedia={i % 2 === 1} />
    ))}
  </div>
);

export default PostListSkeleton;
